import React from "react";

import "./FAQ.css";

const FAQ = (props) => {
	return (
		<div>
			<div className={"page-part-grey"}>
				<div className={"main-text"}>
					<div className="faq-card">
						<h1 className="faq-title">FAQ</h1>

						<div className="faq-item">
							<h2 className="faq-question">Why are you doing this?</h2>
							<div className="faq-answer">
								<p>
									There was a lot of dialog online about which websites predict FPL player points most
									accurately, but none of it was backed up by any facts. I created this website to track
									the most popular free points predictors, gameweek by gameweek, and find out once and for
									all which is best.
								</p>
							</div>
						</div>

						<div className="faq-item">
							<h2 className="faq-question">What is this "combined score" you are using?</h2>
							<div className="faq-answer">
								<p>
									The combined score blends three things, each measured as a % improvement over a simple
									benchmark:
								</p>
								<ul>
									<li>"Error" (RMSE) — how close the predicted points are to what a player actually scored</li>
									<li>"Order" (C-Index) — how well the predictor ranks players relative to each other</li>
									<li>"Returns" — how accurate the predictor is specifically for players who returned (scored 5+ points)</li>
								</ul>
								<p>The combined score is the average of these three.</p>
							</div>
						</div>

						<div className="faq-item">
							<h2 className="faq-question">What is the "benchmark" you compare against?</h2>
							<div className="faq-answer">
								<p>
									The benchmark is a simple model that just predicts every player will score their
									season-average points per game — no fancy modeling involved. Any predictor scoring above
									0% is beating that baseline.
								</p>
							</div>
						</div>

						<div className="faq-item">
							<h2 className="faq-question">Why do I sometimes see a range next to a score?</h2>
							<div className="faq-answer">
								<p>
									With only a handful of gameweeks of data, a single number can be noisy. Click into a
									predictor to see a 95% confidence interval alongside each of its scores, so you can judge
									how reliable the difference between two predictors really is.
								</p>
							</div>
						</div>

						<div className="faq-item">
							<h2 className="faq-question">Cool logo!</h2>
							<div className="faq-answer">
								<p>
									Thanks, but I can't take credit for it. It's a replica of an old design by an Asian clothing
									brand that no longer exists, and the logo is no longer used. If it any point I'm contacted
									by them I will probably remove it — but for now I thought it looked pretty cool!
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default FAQ;
